import {formatInTimeZone, fromZonedTime, toZonedTime} from 'date-fns-tz';
import {format, parseISO} from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

/* eslint-disable */
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/
    );
};
/* eslint-enable */

export const validatePassword = (password) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);

  if (!hasUpperCase || !hasLowerCase || !hasNumber || password.length < 8) {
    return false;
  }

  return true;
};

export const validateLoadMore = (data, meta) => {
  if (data?.length < meta?.total && meta?.offset + meta?.limit < meta?.total) {
    return true;
  }

  return false;
};

export const user = () => {
  return JSON.parse(localStorage.getItem('auth')) ?? false;
};

export const findGameByPath = (games, pathname) =>  {
  const formattedPathname = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  const matchedRoute = games.find(route => route.path === formattedPathname);
  if (matchedRoute) {
    return matchedRoute.game;
  } else {
    return games[0].game;
  }
};

export const parseNum = (n) => {
  if(0 <= n && n < 10000){
    return n;
  } else if(10000 <= n && n < 1000000) {
    return (Math.floor(n / 1000)) + 'K';
  } else if(1000000 <= n) {
    return (Math.floor(n / 1000000)) + 'M';
  } 
};

export const getInitials = (firstName, lastName) => {
  if (!firstName && !lastName) { 
    return ''; 
  }

  const firstInitial = firstName ? firstName.charAt(0) : '';
  const lastInitial = lastName ? lastName.charAt(0) : '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const parseDate = (dateString) => {
  if (!dateString) {
    return null;
  }
  const SYDNEY_TZ = 'Australia/Sydney';
  return formatInTimeZone(dateString, SYDNEY_TZ, 'dd/MM/yyyy');
};

export const buildSydneyDate = (d, hour, minute, second, ms) => {
  console.log(d.toUTCString());
  const dateString =
    `${d.getFullYear()}-` +
    `${String(d.getMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getDate()).padStart(2, '0')} ` +
    `${String(hour).padStart(2, '0')}:` +
    `${String(minute).padStart(2, '0')}:` +
    `${String(second).padStart(2, '0')}.` +
    `${String(ms).padStart(3, '0')}`;

  return fromZonedTime(dateString, 'Australia/Sydney');
};

export const parseDateTime = (dateString) => {
  const SYDNEY_TZ = 'Australia/Sydney';

  try {
    return formatInTimeZone(dateString, SYDNEY_TZ, 'HH:mm dd/MM/yyyy');
  } catch {
    return 'Error';
  }

};

export const filterDate = (type) => {
  const dates = [];
  let endDate = false;

  if (type === 'Today') {
    const currentDate = new Date();
    dates.push(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
      ),
    );
    endDate = true;
  } else if (type === 'Last 7 Days') {
    const currentDate = new Date();
    const last7 = new Date(currentDate);
    last7.setDate(currentDate.getDate() - 6);
    dates.push(
      new Date(last7.getFullYear(), last7.getMonth(), last7.getDate()),
    );
    endDate = true;
  } else if (type === 'This Month') {
    const currentDate = new Date();
    dates.push(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
    endDate = true;
  } else if (type === 'Last Month') {
    const currentDate = new Date();
    dates.push(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
    endDate = true;
  } else if (type === 'Last 3 Month') {
    const currentDate = new Date();
    dates.push(new Date(currentDate.setMonth(currentDate.getMonth() - 3)));
    endDate = true;
  } else if (type === 'This Year') {
    const currentDate = new Date();
    dates.push(new Date(currentDate.setMonth(currentDate.getMonth() - 12)));
    endDate = true;
  }

  if(endDate){
    const endOfDay = new Date();
    dates.push(new Date(endOfDay.setHours(23, 59, 59, 999)));
  }

  return dates;
};

export const formatDate = (utcDateString) => {
  const timeZone = 'Australia/Sydney';
  const utcDate = new Date(utcDateString);
  const zoned = toZonedTime(utcDate, timeZone);
  return format(zoned, 'yyyy-MM-dd\'T\'HH:mm');
};

export const dateToUTC = (localDateString) => {
  if (!localDateString) {
    return null;
  }

  try {
    const parsed = parseISO(localDateString);
    const utcDate = fromZonedTime(parsed, 'Australia/Sydney');
    return utcDate.toISOString();
  } catch {
    return null;
  }

};

export const roundToNearest30Minutes = (isoString) => {
  const date = new Date(isoString);
  const minutes = date.getMinutes();
  const roundedMinutes = Math.round(minutes / 30) * 30;

  if (roundedMinutes === 60) {
    date.setHours(date.getHours() + 1);
    date.setMinutes(0);
  } else {
    date.setMinutes(roundedMinutes);
  }

  date.setSeconds(0);
  date.setMilliseconds(0);
  return date.toISOString();
};

export const transformData = (array) => {
  const result = array.reduce(
    (acc, item) => {
      acc.total += item.value;
      acc.data.push(item.value);
      acc.date.push(item.dates.nominal);
      return acc;
    },
    { total: 0, data: [], date: [] }
  );

  return result;
};

export const groupTagsByChar = (data) => {
  const groupedData = data.reduce((acc, item) => {
    const firstChar = item.name.charAt(0).toUpperCase();
    const key = /^[A-ZА-Я]/.test(firstChar) ? firstChar : '0-9';

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(item);
    return acc;
  }, {});

  return Object.entries(groupedData).sort(([a], [b]) => (a === '0-9' ? -1 : b === '0-9' ? 1 : a.localeCompare(b))).map(([letter, items]) => ({
    letter,
    items,
  }));
};

export const checkPermission = (dataUser, key) => {
  if(dataUser?.role === 'Admin'){
    return true;
  }

  return dataUser?.capabilities?.find(cap => cap.key === key)
    ? dataUser.capabilities.find(cap => cap.key === key).status
    : false;
};

export const getRarityInfo = (rarity) => {
  if(rarity === 1){
    return {
      name: 'Entry',
      bg: '#099BFF'
    };
  } else if(rarity === 2){
    return {
      name: 'Mid',
      bg: '#15FDC7'
    };
  } else if(rarity === 3){
    return {
      name: 'Pro',
      bg: '#FD15CB'
    };
  } else if(rarity === 4){
    return {
      name: 'Elite',
      bg: '#F61717'
    };
  } else if(rarity === 5){
    return {
      name: 'Ultra',
      bg: '#FDC715'
    };
  } else {
    return {
      name: 'Empty',
      bg: '#8490af'
    };
  }
};

export const getFullname = (user) => {
  let fullname = 'Unknown';

  if(user?.firstName){
    fullname = user?.firstName;
  }

  if(user?.lastName){
    const pre = ' ';

    if(user?.firstName === null){ 
      fullname = ''; 
      pre = ''; 
    }

    fullname += pre + user?.lastName;
  }

  if(fullname === 'Unknown' && user?.username){
    fullname = user?.username;
  }

  return fullname;
};

export const getCurrencySymbol = (currencyCode) => {
  try {
    return (0).toLocaleString('en', {
      style: 'currency',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).replace(/\d/g, '').trim();
  }catch {
    return '';
  }

};

export function priceToCents(value) {
  return Number((value * 100).toFixed(1));
}

export function centsToPrice(value) {
  return Number((value / 100).toFixed(3));
}